<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="stocksSelected"
    :clearable="!unclearable"
    chips
    multiple
    deletable-chips
    small-chips
    :items="stocksItems"
    :loading="stocksLoading"
    :search-input.sync="stocksSearch"
    item-text="Description"
    item-value="id"
    :label="noLabel ? '' : $t('Stock.ObjectName')"
    return-object
    :single-line="singleLine"
    :dense="dense"
    :hide-details="hideDetails"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  ></v-autocomplete>
</template>

<script>
import i18n from "@/i18n";
import Stocks from "@/api/stocks";

export default {
  name: "SearcherStocks",

  props: {
    value: Array,
    stockDistrict: Object,
    noLabel: Boolean,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    stockTypes: Array,
    stockId: [Number, String],
  },

  computed: {
    stocksItems() {
      var stocks;
      if (this.stockDistrict) {
        stocks = this.stocks.filter(
          (stock) => stock.stock_district_code == this.stockDistrict.code
        );
      } else {
        stocks = this.stocks;
      }
      return stocks.map((stock) => {
        const Description = stock.code + " / " + stock.name;
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == stock.id
            )
          : false;
        return Object.assign({}, stock, { Description, disabled });
      });
    },
  },

  data: () => ({
    stocks: [],
    stocksLoading: false,
    stocksSearch: "",
    stocksSelected: [],
  }),

  mounted() {
    this.getStocksFromAPI()
  },

  methods: {
    getStocksFromAPI() {
      this.stocksLoading = true;
      Stocks.fetchAllForSelect({ types: this.stockTypes }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stocks = [];
            this.stocks.push({
              id: 0,
              code: '',
              name: i18n.t("summaryMonthlyStatementDetail.refund")
            })
            response.data.stocks.map((stock) => {
              this.stocks.push(stock)
            });
            if (this.$route.query.stock_ids) {
              let numArr = this.$route.query.stock_ids.split(","); // [x,x,x,x]
              let new1 = numArr.map((item) => {
                return { id: item };
              });
              // 过滤出 this.stocks 中id为 numArr 的数据
              let newArr = this.stocks.filter((item) => new1.some((v) => v.id == item.id));
              this.stocksSelected = newArr;
            }
            if (this.stockId != null) {
              // 过滤出 this.stocks 中id为 numArr 的数据
              let newArr = this.stocks.filter((item) => item.id == this.stockId);
              this.stocksSelected = newArr;
            }
          }
          this.stocksLoading = false;
        }.bind(this)
      ).catch(
        function () {
          this.stocksLoading = false;
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.stocksSelected = this.value;
      },
    },
    stocksSelected: {
      handler() {
        this.$emit("input", this.stocksSelected);
      },
    },
  },
};
</script>